import { createContext } from 'react'
import type { Profile, ProfileEndpoints } from '@bandos/shared'
import type { ApiResponse } from '@bandos/shared'

export interface ProfileContextType {
  profile: Profile | null
  loading: boolean
  updateProfile: (
    updates: ProfileEndpoints['update']['body']
  ) => Promise<ApiResponse<ProfileEndpoints['update']['response']>>
  reloadProfile: () => Promise<void>
}

export const ProfileContext = createContext<ProfileContextType | undefined>(undefined)
